import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AllRoleButton from '../../../../components/buttons/AllRoleButton';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useEffect, useState } from 'react';
import { ChipSelect } from '../../../../components/inputs/ChipSelect';
import { getAllCategories, getAllMunicipalities, getAllBusinessTypes } from '../../../../store/actions/actions';

export const BusinessFilter = ({
  categoryChips,
  setCategoryChips,
  entityTypeChips,
  setEntityTypeChips,
  municipalityChips,
  setMunicipalityChips,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [selectedMunicipality, setSelectedMunicipality] = useState('choose');
  const [selectedEntityType, setSelectedEntityType] = useState('choose');
  const [selectedCategory, setSelectedCategory] = useState('choose');

  const categoriesResponse = useSelector(({ categories }) => categories.getAll);
  const entityTypesResponse = useSelector(({ businessTypes }) => businessTypes.getAll);
  const municipalitiesResponse = useSelector(({ municipalities }) => municipalities.getAll);
  const language = useSelector((state) => state.language);

  useEffect(() => {
    dispatch(getAllCategories({ pagination: false, language }));
    dispatch(getAllBusinessTypes({ pagination: false, language }));
    dispatch(getAllMunicipalities({ pagination: false, language }));
  }, []);

  const onCategoryChange = (category, type) => {
    switch (type) {
      case 'add':
        const exists = categoryChips.find((chip) => chip._id === category._id);
        if (exists) return;

        const addedArray = [...categoryChips, category];
        setCategoryChips(addedArray);
        setSelectedCategory(category._id);
        break;
      case 'delete':
        const filteredArray = categoryChips.filter((chip) => chip._id !== category._id);
        setCategoryChips(filteredArray);
        setSelectedCategory('choose');
        break;
      default:
        break;
    }
  };
  const onEntityTypeChange = (entityType, type) => {
    switch (type) {
      case 'add':
        const exists = entityTypeChips.find((chip) => chip._id === entityType._id);
        if (exists) return;

        const addedArray = [...entityTypeChips, entityType];
        setEntityTypeChips(addedArray);
        setSelectedEntityType(entityType._id);
        break;
      case 'delete':
        const filteredArray = entityTypeChips.filter((chip) => chip._id !== entityType._id);
        setEntityTypeChips(filteredArray);
        setSelectedEntityType('choose');
        break;
      default:
        break;
    }
  };
  const onMunicipalityChange = (municipality, type) => {
    switch (type) {
      case 'add':
        const exists = municipalityChips.find((chip) => chip._id === municipality._id);
        if (exists) return;

        const addedArray = [...municipalityChips, municipality];
        setMunicipalityChips(addedArray);
        setSelectedMunicipality(municipality._id);
        break;
      case 'delete':
        const filteredArray = municipalityChips.filter((chip) => chip._id !== municipality._id);
        setMunicipalityChips(filteredArray);
        setSelectedMunicipality('choose');
        break;
      default:
        break;
    }
  };

  const resetFilters = () => {
    setSelectedMunicipality('choose');
    setSelectedEntityType('choose');
    setSelectedCategory('choose');
    setCategoryChips([]);
    setMunicipalityChips([]);
    setEntityTypeChips([]);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="categories"
              label={t('filter-interest')}
              selectLabel={t('chooseCategories')}
              handleChange={(e) => onCategoryChange(JSON.parse(e.target.value), 'add')}
              value={selectedCategory}
              data={
                categoriesResponse?.success && categoriesResponse.data?.categories?.docs
                  ? categoriesResponse.data.categories.docs
                  : []
              }
              valueChips={categoryChips}
              handleDelete={onCategoryChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="entityTypes"
              label={t('businessTypes')}
              selectLabel={t('chooseEntityType')}
              handleChange={(e) => onEntityTypeChange(JSON.parse(e.target.value), 'add')}
              value={selectedEntityType}
              data={
                entityTypesResponse?.success && entityTypesResponse.data?.businesstypes?.docs
                  ? entityTypesResponse.data.businesstypes.docs
                  : []
              }
              valueChips={entityTypeChips}
              handleDelete={onEntityTypeChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="municipalities"
              label={t('Komuna')}
              selectLabel={t('ChooseMunicipality')}
              handleChange={(e) => onMunicipalityChange(JSON.parse(e.target.value), 'add')}
              value={selectedMunicipality}
              data={
                municipalitiesResponse?.success && municipalitiesResponse.data?.municipalities?.docs
                  ? municipalitiesResponse.data.municipalities.docs
                  : []
              }
              valueChips={municipalityChips}
              handleDelete={onMunicipalityChange}
            />
          </Grid>
          {/* <Grid item md={3} lg={3} sx={{ display: { xs: 'none', md: 'block' } }} /> */}

          <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mt: { md: 3.5, lg: 3.6, xl: 3.6 } }}>
            <AllRoleButton
              label={t('resetFilters')}
              handleClick={() => resetFilters()}
              backgroundColor={'#EC5624'}
              icon={<RemoveCircleOutlineIcon />}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
